export enum TechnologyRestrictedByCnaeEnum {
  E_COMMERCE = '334',
  PAY_LINK = '399',
  E_COMMERCE_IPG = '356',
}
